import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EmployeePaySlipsSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/members/$employeeId/')({
  validateSearch: zodValidator(EmployeePaySlipsSearchSchema)
});